import profiler from '@/helpers/userProfile';
const [, updateProfile] = profiler();

function sendUpdatestoProfile(address: {
	city: string;
	state: string;
	postcode: string;
}) {
	updateProfile('city', address.city);
	updateProfile('state', address.state);
	updateProfile('zip', address.postcode);
}
export default sendUpdatestoProfile;
